/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  // 28-ago — LLAMADA DE FONDO: NO DEBE DISPARAR EL TOAST GLOBAL DE 403.
  //
  // `ContactPanel` la despacha en `onMounted` para saber si Linear está conectado, o sea UNA VEZ
  // POR CONVERSACIÓN ABIERTA, sin que la persona pida nada. Desde que las integraciones pasaron a
  // ser sólo del `administrator`, para un agente eso es un 403 — correcto y no accionable por él.
  //
  // El problema no es el 403 sino quién lo anuncia: el interceptor de APIHelper.js:154 muestra un
  // toast en CUALQUIER 403, antes de que el `catch` del store se lo trague. Resultado en
  // producción: una lluvia de «No tienes los permisos necesarios» que se acumula conversación
  // tras conversación y hace parecer que el panel está roto cuando no lo está.
  //
  // `skipForbiddenToast` es el mecanismo que el propio repositorio ya creó para esto — ver
  // `contacts.js#getContactableInboxes`, mismo caso exacto: llamada de fondo, permiso que el
  // agente no necesita, toast que asusta sin informar. El error sigue llegando al `catch` del
  // store, así que el comportamiento no cambia: sin integraciones, Linear queda oculto.
  get() {
    return axios.get(this.url, { skipForbiddenToast: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  connectShopify({ shopDomain }) {
    return axios.post(`${this.baseUrl()}/integrations/shopify/auth`, {
      shop_domain: shopDomain,
    });
  }
}

export default new IntegrationsAPI();
